import { FC, type HTMLAttributeAnchorTarget } from 'react';

// ========================= 组件 =========================
import { Navigation, Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperToggleButton from '../SwiperToggleButton';

// ========================= 数据交互 =========================

// ========================= 全局数据 =========================

// ========================= 常量 =========================

// ========================= 工具 =========================
import classnames from 'classnames';

// ========================= 样式 =========================
import 'swiper/css';
import 'swiper/css/navigation';
import styles from './index.module.css';
import { v4 as uuidv4 } from 'uuid';
import Link from '../link';

// ========================= 变量 =========================

// ========================= 类型 =========================

interface ConferenceHorizontalSwiperProps<T = any> {
    /**
     * @description: item数据
     * @return {*}
     */
    items: T[];
    /**
     * @description: item渲染个数
     * @return {*}
     */
    slidesPerView?: number;
    /**
     * @description: item渲染函数
     * @return {*}
     */
    itemRender?: (item: T, index: number) => React.ReactNode;
    /**
     * @description: valuePropName
     * @return {*}
     */
    valuePropName?: string;

    onClick?: (item: T, index: number) => void;

    href?: string | ((item: T, index: number) => string);
    target?: HTMLAttributeAnchorTarget;

    containerMaxWidth?: number | string;
    swiperSlideHeight?: number | string | 'auto';

    swiperSlideClassName?: string;
    swiperSlideStyle?: React.CSSProperties;
    autoHeight?: boolean;

    /**
     * @description: navigation配置
     * @return {*}
     */
    prevEl?: string;
    nextEl?: string;
    disabledClass?: string;
}
/**
 * @description: 大会专区-会议亮点轮播
 * @param {*} props
 * @return {*}
 */
const ConferenceHorizontalSwiper: FC<ConferenceHorizontalSwiperProps> = ({
    items = [],
    slidesPerView = 4,
    valuePropName = '',
    autoHeight = false,
    href = '',
    target,
    prevEl = `swiper-button-prev-${uuidv4()}`,
    nextEl = `swiper-button-next-${uuidv4()}`,
    swiperSlideClassName,
    swiperSlideStyle,
    onClick,
    itemRender
}) => {

    if (items.length === 0) {
        return null;
    }

    return (
        <div
            className={styles.container}
        >
            <Swiper
                className={styles['swiper-container']}
                slidesPerView={slidesPerView} //设置显示的数量
                spaceBetween={15} // 设置堆叠轮播，item之间叠的距离
                grabCursor={true} // 鼠标移动到slide上时变成手型
                modules={[Navigation, Mousewheel]}
                navigation={{
                    prevEl: `.${prevEl}`,
                    nextEl: `.${nextEl}`,
                }}
                mousewheel={{
                    forceToAxis: true,
                }}
                centerInsufficientSlides={true} // 添加此属性，使得不足的slide居中显示
                autoHeight={autoHeight} // 添加此属性，使得Swiper高度自适应
                breakpoints={{
                    768: {
                        slidesPerView: 2,
                    },
                    960: {
                        slidesPerView: 3,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                    1280: {
                        slidesPerView: 3,
                    },
                    1440: {
                        slidesPerView: 4,
                    },
                }}
            >
                {
                    items.map((item, index) => {

                        const path = typeof href === 'string' ? href : href(item, index);

                        const imageContext = (
                            <img
                                style={{
                                    objectFit: 'cover',
                                }}
                                className={styles['slide-image']}
                                src={valuePropName ? item[valuePropName] : item}
                                alt=''
                            />
                        )

                        const imageRender = path ? (
                            <Link
                                href={path}
                                target={target}
                                className={styles['link']}
                            >
                                {imageContext}
                            </Link>
                        ) : imageContext;


                        return (
                            <SwiperSlide
                                key={`swiperSlide_${index}`}
                                className={classnames(styles['swiper-slide-item'], swiperSlideClassName)}
                                style={swiperSlideStyle}
                                onClick={() => onClick && onClick(item, index)}
                            >
                                {
                                    itemRender
                                        ? itemRender(item, index)
                                        : imageRender
                                }
                            </SwiperSlide>
                        )
                    })
                }
            </Swiper>
            {/* 向左切换 */}
            <SwiperToggleButton
                direction="prev"
                className={classnames(styles['swiper-button-prev'], prevEl)}
            />
            {/* 向右切换 */}
            <SwiperToggleButton
                direction="next"
                className={classnames(styles['swiper-button-next'], nextEl)}
            />
        </div>
    );
}
export default ConferenceHorizontalSwiper;